import { AnimalScreeningReportVendors } from "shared/types";
import {
  OurPetPolicyAnimal,
  OurPetPolicyLandlordStatus,
  OurPetPolicyStatus
} from "./types/our-pet-policy";
import { PetScreeningAnimal, PetScreeningStatus } from "./types/pet-screening";
import { BadgeVariant } from "shared/components";

export const getVerificationStatusByVendor = (
  pet: PetScreeningAnimal | OurPetPolicyAnimal,
  vendor: AnimalScreeningReportVendors
  // eslint-disable-next-line sonarjs/function-return-type -- polymorphism
): PetScreeningStatus | OurPetPolicyLandlordStatus => {
  if (vendor === AnimalScreeningReportVendors.PetScreening)
    return (pet as PetScreeningAnimal).status;
  return (pet as OurPetPolicyAnimal).verification_status;
};

export const statusBadgeVariant = (
  status: OurPetPolicyStatus | PetScreeningStatus
): BadgeVariant => {
  switch (status) {
    case OurPetPolicyStatus.PENDING:
    case PetScreeningStatus.draft:
    case PetScreeningStatus.verifying:
    case PetScreeningStatus.non_responsive:
      return BadgeVariant.WARNING;
    case OurPetPolicyStatus.APPROVED:
    case PetScreeningStatus.active:
    case PetScreeningStatus.recommended:
    case PetScreeningStatus.conditionally_recommended:
      return BadgeVariant.SUCCESS;
    case OurPetPolicyStatus.NOT_APPROVED:
    case PetScreeningStatus.declined:
    case PetScreeningStatus.expired:
    case PetScreeningStatus.returned:
      return BadgeVariant.ERROR;
    default:
      return BadgeVariant.BASE;
  }
};
